import React from 'react';
import PropTypes from 'prop-types';
import styles from './AboutBio.module.scss';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';

// Format of bio data:
  // {
  //   name: string,
  //   role: string,
  //   bio: string,
  //   contribution: string,
  //   contact: string,   (email)
  //   ORCID: string,
  //   affiliation: string,
  //   affiliationLink: string,
  //   photo: string,
  //   sortOrder: number
  // },

  // TODO need to add a close button to form.
const image_path = '';

const BioDetail = (props) => {

  const image_full_path = props.Bio.photo ? image_path + props.Bio.photo : '';

  console.log('BioDetail props', props);
  console.log('BioDetail image_full_path', image_full_path);

  return (
    <div className={styles.outerContainer}>
      <div>
        <div className={styles.bioContact}>        
          <div className={styles.columns3070}>
            <div className={styles.column1} >
              <img className={styles.bioPhoto} src={image_full_path} alt="Personal" />
            </div>
            <div className={styles.column2}>
              <div className={styles.bioName}>
                {props.Bio.name}
              </div>
              {props.Bio.role && <div className={styles.bioRow}>
                <Typography variant="body1" className={styles.bioTitle} gutterBottom>
                  Role: 
                </Typography>
                <Typography variant="body1" className={styles.bioText} gutterBottom>
                  {props.Bio.role}
                </Typography>
              </div>}
              {props.Bio.ORCID && <div className={styles.bioRow}>
                <Typography variant="body1" className={styles.bioTitle} gutterBottom>
                  ORCID: 
                </Typography>
                <Typography variant="body1" className={styles.bioText} gutterBottom>
                  <a href={props.Bio.ORCID} target="_blank" rel="noreferrer">{props.Bio.ORCID}</a>
                </Typography>
              </div>}
              {props.Bio.contact && <div className={styles.bioRow}>
                <Typography variant="body1" className={styles.bioTitle} gutterBottom>
                  Contact: 
                </Typography>
                <Typography variant="body1" className={styles.bioText} gutterBottom>
                  {props.Bio.contact}
                </Typography>
              </div>}
              {props.Bio.affiliation && <div className={styles.bioRow}>
                <Typography variant="body1" className={styles.bioTitle} gutterBottom>
                  Affiliation: 
                </Typography>
                <Typography variant="body1" className={styles.bioText} gutterBottom>
                  {props.Bio.affiliation}
                </Typography>
              </div>} 
              {props.Bio.affiliationLink && <div className={styles.bioRow}>
                <Typography variant="body1" className={styles.bioTitle} gutterBottom>
                  Affiliation Link: 
                </Typography>
                <Typography variant="body1" className={styles.bioText} gutterBottom>
                  <a href={props.Bio.affiliationLink} target="_blank" rel="noreferrer">{props.Bio.affiliationLink}</a>
                </Typography>
              </div>}
            </div>    
          </div>
        </div>

        <div className={styles.bioStory}>
          <div className={styles.column2}>
            {props.Bio.contribution && <div className={styles.bioRow}>
              <Typography variant="body1" className={styles.bioTitle} gutterBottom>
                Contribution: 
              </Typography>
              <Typography variant="body1" className={styles.bioText} gutterBottom >
                <div dangerouslySetInnerHTML={{ __html: props.Bio.contribution }} />
              </Typography>
            </div>}
            {props.Bio.bio && <div className={styles.bioRow}>
              <Typography variant="body1" className={styles.bioTitle} gutterBottom>
                Biography: 
              </Typography>
              <Typography variant="body1" className={styles.bioText} gutterBottom>
                <div dangerouslySetInnerHTML={{ __html: props.Bio.bio }} />
              </Typography>
            </div>}
          </div>      
        </div>
      </div>

      <div >
        <div className={styles.bioButtons}>
          <Button variant="contained" onClick={props.OnClose} styles={{height: '32px' }} >
            Close
          </Button>
        </div>
      </div>

    </div>
  )
}

BioDetail.propTypes = {
  Bio: PropTypes.object.isRequired,
  OnClose: PropTypes.func.isRequired,
};  

export default BioDetail;
